module.exports = __webpack_public_path__ + "static/media/menu-vertical.1fbc28e9.svg";